export const INSERISCI_MODIFICA_ANAGRAFICA_SUCCESS = 'INSERISCI_MODIFICA_ANAGRAFICA_SUCCESS';
export const INSERISCI_MODIFICA_ANAGRAFICA_FAIL = 'INSERISCI_MODIFICA_ANAGRAFICA_FAIL';

export const INIT_ANAGRAFICA_RUOLI = 'INIT_ANAGRAFICA_RUOLI';



